<template>
  <div class="contact">
    <div class="contact__title">
      <h2 class="contact__title--white">{{ $t('contact.title') }}</h2>
    </div>
    <div class="contact__body">
      <el-card class="contact__body__card">
        <Creation />
      </el-card>
      <el-card class="contact__body__card">
        <ContactList />
      </el-card>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Creation from '@/components/contact/Creation.vue';
import ContactList from '@/components/contact/ContactList.vue';

export default {
  name: 'contact',
  components: {
    Creation,
    ContactList,
  },
  computed: {
    ...mapGetters({
      projectSelected: 'projectStore/projectSelected',
    }),
  },
  methods: {
    ...mapActions({
      getContacts: 'contactStore/getContacts',
    }),
  },
  created() {
    this.getContacts();
  },
  watch: {
    projectSelected() {
      this.getContacts();
    },
  },
};
</script>

<style lang="scss" scoped>
  .contact {
    min-height: 600px;
    margin: 0;
    @include breakpoint(tablet) {
      margin: 0 20px;
    }
    @include breakpoint(wide) {
      margin: 0 $--wide-margin;;
    }
    @include breakpoint(wide-xl) {
      margin: 0 $--wide-xl-margin;
    }
    &__title {
      margin-top: 20px;
      margin-left: 20px;
      @include breakpoint(tablet) {
        margin-left: 0px;
      }
      &--white {
        color: $--color-white;
      }
    }
    &__body {
      position: relative;
      &__card {
        border-radius: 0;
        margin-bottom: 20px;
        @include breakpoint(tablet) {
          border-radius: 4px;
        }
      }
    }
  }
</style>
